import Nav from 'react-bootstrap/Nav';
import Button from 'react-bootstrap/Button';
import {useAuth} from "../../AuthUser";
import { useNavigate, NavLink } from "react-router-dom";
import { useState } from 'react';
import Offcanvas from 'react-bootstrap/Offcanvas';

function AdminNavigation({ hideAuthButton = false }) {
	const navigate = useNavigate();
	const auth = useAuth();
	const isAdmin = auth?.user?.admin;

	const [show, setShow] = useState(false);

	const handleClose = () => setShow(false);
	const handleShow = () => setShow(true);

	const AdminLink = () => {
			if (isAdmin) {
				return <Button variant="outline-light" size="md" onClick={() => navigate("/signin", {replace: true})}>Member Login</Button>;
			}
	};

	const dropdown = () => {
		return <i className="bi bi-person-circle" style={{fontSize: "1.5rem"}}/>;
	};

	return (
		<>
			<Button variant="primary" className="d-lg-none" onClick={handleShow}>
				Menu
			</Button>
			<Offcanvas show={show} onHide={handleClose} responsive="lg">
				<Offcanvas.Header closeButton>
				</Offcanvas.Header>
				<Offcanvas.Body>
					<Nav defaultActiveKey="/admin/lessons" className="flex-column sidebar">
						<Nav.Link as={NavLink} to="/admin/lessons">Lessons</Nav.Link>
						<Nav.Link as={NavLink} to="/admin/lessonComments">Lesson Comments</Nav.Link>
						<Nav.Link as={NavLink} to="/admin/users" end>Users</Nav.Link>
						<Nav.Link as={NavLink} to="/admin/users/create">Create User</Nav.Link>
						<Nav.Link as={NavLink} to="/admin/videos" end>Videos</Nav.Link>
						<Nav.Link as={NavLink} to="/admin/videos/create">Create Video</Nav.Link>
						<Nav.Link as={NavLink} to="/admin/category" end>Categories</Nav.Link>
						<Nav.Link as={NavLink} to="/admin/category/create">Create Category</Nav.Link>
						<Nav.Link as={NavLink} to="/admin/plans" end>Plans</Nav.Link>
						<Nav.Link as={NavLink} to="/admin/plans/create">Create Plan</Nav.Link>
						<Nav.Link as={NavLink} to="/admin/discount-offers" end>Offer Links</Nav.Link>
						<Nav.Link as={NavLink} to="/admin/faq" end>FAQs</Nav.Link>
						<Nav.Link as={NavLink} to="/admin/faq/create">Create FAQ</Nav.Link>
						<Nav.Link as={NavLink} to="/admin/faq/category">FAQ Categories</Nav.Link>
						<Nav.Link as={NavLink} to="/admin/faq/category/create">Create FAQ Category</Nav.Link>

					</Nav>
				</Offcanvas.Body>
			</Offcanvas>
		</>
	);
}

export default AdminNavigation;
